let applePayPromise: Promise<void> | null = null;

export function loadApplePay() {
  if (window.ApplePaySession) {
    return Promise.resolve();
  }

  if (applePayPromise) {
    return applePayPromise;
  }

  applePayPromise = new Promise((resolve) => {
    const script = document.createElement('script');
    script.src =
      'https://applepay.cdn-apple.com/jsapi/v1.2.0-beta/apple-pay-sdk.js';
    script.async = true;
    script.crossOrigin = 'anonymous';

    script.onload = () => resolve();

    document.body.appendChild(script);
  });

  return applePayPromise;
}
